export const costs = [
  'Sleepless nights searching for ways to translate complex wine concepts into language your students can understand.',
  "Improvised classes because you couldn't find clear, ready-to-use materials in time.",
  "Disconnected students who don't see how wine studies connects to careers in hospitality, gastronomy, or wine production.",
  "Awkward silences when a student asks about tannin structure or aging potential and you don't have a clear answer.",
  'Weekends lost building lesson plans, tasting projects, and assessments from scratch over and over.',
  'Uncertainty about how to teach viticulture, winemaking science, or sensory analysis without adequate resources.',
];
